import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension/logOnlyInProduction";
import { Reducers } from "./reducers";
import { TServices } from "../@types/TServices";
import { makeInjectedServices } from "../factories/makeInjectedServices";

const composeEnhancers = composeWithDevTools({});
export const store = createStore(
  Reducers,
  composeEnhancers(
    applyMiddleware(thunk.withExtraArgument<TServices>(makeInjectedServices()))
  )
);
